module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.origin !== 'yirui') ? _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "sidebar-logo__wrapper"
  }, [_c('img', {
    staticClass: "sidebar-img",
    attrs: {
      "src": require("./img/logo.png"),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "sidebar-logo__title"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('ul', {
    staticClass: "left-nav"
  }, [_vm._l((_vm.navs), function(nav, index) {
    return _c('li', [(nav.pathname) ? _c('router-link', {
      staticClass: "sidebar-nav__item",
      attrs: {
        "to": _vm.router('main/' + nav.pathname)
      }
    }, [_vm._v(_vm._s(nav.val))]) : _c('a', {
      staticClass: "sidebar-nav__item",
      class: {
        'dark': _vm.subNavDark(_vm.$route.fullPath, nav.subnav)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(nav.subnav)
        }
      }
    }, [_vm._v("\n        " + _vm._s(nav.val) + "\n        "), (nav.sub) ? _c('i', {
      staticClass: "icon-down_arrow",
      class: {
        'icon-down_arrow__rotate': _vm.isSlides[nav.subnav]
      }
    }) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "collpase"
      }
    }, [(nav.sub) ? _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isSlides[nav.subnav]),
        expression: "!isSlides[nav.subnav]"
      }],
      staticClass: "collpase",
      class: {
        'dark': _vm.subNavDark(_vm.$route.fullPath, nav.subnav)
      }
    }, [_vm._l((nav.sub), function(subnav) {
      return _c('li', [_c('router-link', {
        staticClass: "sidebar-nav__item sidebar-nav__subitem",
        attrs: {
          "to": _vm.router('main/' + subnav.pathname)
        }
      }, [_vm._v("\n              " + _vm._s(subnav.val) + "\n            ")])], 1)
    }), _vm._v(" "), (nav.subnav === 'member' && _vm.role.isClound && _vm.role.single) ? _c('li', [_c('router-link', {
      staticClass: "sidebar-nav__item sidebar-nav__subitem",
      attrs: {
        "to": {
          name: 'memberIntegral'
        }
      }
    }, [_vm._v("会员积分")])], 1) : _vm._e()], 2) : _vm._e()])], 1)
  }), _vm._v(" "), (_vm.role.qimai) ? _c('li', [_c('router-link', {
    staticClass: "sidebar-nav__item",
    attrs: {
      "to": {
        path: '/main/littleStore'
      }
    }
  }, [_vm._v("\n              好近小店二维码\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.role.diancan && !_vm.role.isCashier) ? _c('li', {
    class: {
      'dark': _vm.subNavDark(_vm.$route.fullPath, 'dinner')
    }
  }, [_c('a', {
    staticClass: "sidebar-nav__item",
    on: {
      "click": function($event) {
        return _vm.toggle('dinner')
      }
    }
  }, [_vm._v("\n        智慧餐厅\n        "), _c('i', {
    staticClass: "icon-down_arrow",
    class: {
      'icon-down_arrow__rotate': _vm.isSlides['dinner']
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collpase"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSlides['dinner']),
      expression: "!isSlides['dinner']"
    }],
    staticClass: "collpase"
  }, [_c('li', [_c('router-link', {
    staticClass: "sidebar-nav__item sidebar-nav__subitem",
    attrs: {
      "to": {
        name: 'hasPublic',
        params: {
          hasPublic: 'yes'
        }
      }
    }
  }, [_vm._v("\n              有公众号二维码\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "sidebar-nav__item sidebar-nav__subitem",
    attrs: {
      "to": {
        name: 'noPublic',
        params: {
          hasPublic: 'no'
        }
      }
    }
  }, [_vm._v("\n              无公众号二维码\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "sidebar-nav__item sidebar-nav__subitem",
    attrs: {
      "to": {
        path: '/main/merchandise'
      }
    }
  }, [_vm._v("商品管理")])], 1)])])], 1) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0e94cdcf"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/sidebar.vue
// module id = 809
// module chunks = 0